module.exports={
	"Form": "ProductionPlantViewManifest",
	"Scope": "ProductionPlant-View",
	"Descriptors":
	{
		"ProductionPlantDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProductionPlant-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ProductionPlant-View-Identity",
				"Group": "ProductionPlant-View-Identity"
			}
		},
		"ProductionPlantDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "ProductionPlant-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-View-Details",
				"Group": "ProductionPlant-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"ProductionPlantDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "ProductionPlant-View-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-View-Details",
				"Group": "ProductionPlant-View-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				],
				"ReadOnly": true
			}
		},
		"ProductionPlantDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "ProductionPlant-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "ProductionPlant-View-Details",
				"Group": "ProductionPlant-View-Details"
			}
		},
		"ProductionPlantDetails.ExternalProductionPlantID":
		{
			"Name": "External Production Plant ID",
			"Hash": "ProductionPlant-View-ExternalProductionPlantID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "ProductionPlant-View-Details",
				"Group": "ProductionPlant-View-Details"
			}
		},
		"ProductionPlantDetails.IDProductionPlant":
		{
			"Name": "IDProduction Plant",
			"Hash": "ProductionPlant-View-IDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		},
		"ProductionPlantDetails.GUIDProductionPlant":
		{
			"Name": "GUIDProduction Plant",
			"Hash": "ProductionPlant-View-GUIDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		},
		"ProductionPlantDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "ProductionPlant-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		},
		"ProductionPlantDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "ProductionPlant-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		},
		"ProductionPlantDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "ProductionPlant-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		},
		"ProductionPlantDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "ProductionPlant-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-View-DataAudit",
				"Group": "ProductionPlant-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProductionPlant-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProductionPlant-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "ProductionPlant-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "ProductionPlant-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "ProductionPlant-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "ProductionPlant-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
